<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-05-07 16:33:22
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Announcement\editAnnouncement.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 11:19:51
-->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="
      iSEdited
        ? $t('label_essweb_Announcement_form_editTitle')
        : $t('label_essweb_Announcement_form_viewTitle')
    "
    backgroundClass="white"
    :editBtn="!iSEdited && hasBtn('edit-company-announcement')"
    :initData="announcementData"
    @change="(changed) => (isChanged = changed)"
    :checkData="['message_title', 'message_content', 'send_org_level_uuid']"
    :delBtn="hasBtn('delete-company-announcement')"
    @delete="
      $confirmDo($t('label_essweb_admin_Announcement_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
    @edit="iSEdited = true"
  >
    <template v-slot:appendTitle>
      <v-chip small class="pl-0 ml-2 pr-2 mr-4" pill v-if="announcementData">
        <svg-icon
          size="18"
          :fill="
            Number(announcementData.send_status) == 0
              ? 'green'
              : Number(announcementData.send_status) == 1
              ? 'orange'
              : Number(announcementData.send_status) == 2
              ? 'grey'
              : 'grey'
          "
          iconClass="LabeledColour"
          class="mr-1"
        />
        <template>
          {{ $getCommonLangValue(announcementData.send_status_detail) }}
        </template>
      </v-chip>
    </template>
    <template v-slot:nav-actions> </template>
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              :readonly="!iSEdited"
              :filled="iSEdited"
              v-model="announcementData.message_title"
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="200"
              :label="
                $t('label_essweb_Announcement_form_announcementTitleLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              isRequire
              :readonly="!iSEdited"
              :filled="iSEdited"
              type="datetimerange"
              :value="dateTerminal"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :defaultStartTime="announcementData.send_start_utc_datetime"
              :defaultEndTime="announcementData.send_end_utc_datetime"
              :label="$t('label_essweb_Announcement_form_publicTimeLabel')"
              @change="
                (time, isre) => {
                  dateTerminal = time;
                  if (isre) {
                    announcementData.send_start_utc_datetime = time
                      ? time.split(' - ')[0]
                      : '';
                    announcementData.send_end_utc_datetime = time
                      ? time.split(' - ')[1]
                      : '';
                  }
                }
              "
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_Announcement_form_orgLeaveLabel")
            }}</v-sheet>
            <v-combobox
              v-model="announcementData.send_org_level_uuid"
              :items="[]"
              multiple
              :readonly="!iSEdited"
              :filled="iSEdited"
              append-icon=""
              item-color="transparent"
              small-chips
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              dense
              single-line
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  pill
                  class="mx-1 my-1"
                  :input-value="data.selected"
                  v-if="data.index < $selectSetting.maxChips"
                  @click="data.select"
                  :close="iSEdited"
                  @click:close="removeOrg(data.item)"
                >
                  {{ $getCommonLangValue(data.item.org_level_name) }}
                </v-chip>
                <span
                  v-if="data.index === $selectSetting.maxChips"
                  class="text--primary py-2"
                >
                  ...{{
                    announcementData.send_org_level_uuid.length -
                    $selectSetting.maxChips
                  }}{{ $t("label_essweb_selection_moreItemLabel") }}
                </span>
              </template>
              <template v-slot:no-data>
                <noContent v-if="orgData.length == 0" />
                <v-treeview
                  selectable
                  v-else
                  open-all
                  open-on-click
                  :search="search"
                  :filter="filter"
                  selected-color="primary"
                  :items="orgData"
                  item-key="uuid"
                  v-model="announcementData.send_org_level_uuid"
                  return-object
                  item-text="org_level_name"
                  item-children="son_org"
                >
                  <template v-slot:label="{ item }">
                    <span
                      class="text--secondary"
                      v-html="hightLightKeyword(item.org_level_name, search)"
                    ></span>
                  </template>
                </v-treeview>
              </template>
            </v-combobox>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">
              {{ $t("label_essweb_Announcement_form_contentLabel") }}
            </v-sheet>
            <v-textarea
              rows="5"
              no-resize
              :readonly="!iSEdited"
              :filled="iSEdited"
              maxlength="500"
              v-model="announcementData.message_content"
              dense
              :rules="$GetRules(['_Require_Rules'], [null])"
              counter="500"
              single-line
            ></v-textarea>
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12">
            <v-checkbox
              v-model="announcementData.is_confirm_read"
              :disabled="!iSEdited"
              :label="$t('label_essweb_Announcement_form_confirmReadLabel')"
              required
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        saveBtn
        @save="toSave"
        @cancel="toBack(isChanged)"
        v-if="iSEdited"
      />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newAnnouncement",
  computed: {
    ...mapGetters(["companyLang", "AppInfo", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    filter() {
      return (item, search, textKey) =>
        this.$getCommonLangValue(item[textKey]).indexOf(search) > -1;
    },
    curSend() {
      let arr = [];
      const that = this;
      if (!that.announcementData.send_org_level_uuid) arr = [];
      function getSon(items) {
        let arr1 = [];
        items.map((item) => {
          if (
            that.announcementData.send_org_level_uuid.indexOf(item.uuid) != -1
          ) {
            arr1.push(item);
          }
          if (item.son_org && item.son_org.length) {
            arr1 = arr1.concat(getSon(item.son_org));
          }
        });
        return arr1;
      }
      if (that.orgData.length) arr = getSon(that.orgData);
      return arr;
    },
  },
  data() {
    return {
      search: "",
      dateTerminal: "",
      iSEdited: false,
      isChanged: false,
      orgData: [],
      announcementData: {
        message_title: "",
        send_status: 2,
        send_status_detail: "",
        is_confirm_read: false,
        send_org_level_uuid: [],
        message_content: "",
        send_end_utc_datetime: "",
        send_start_utc_datetime: "",
      },
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getOrgList();
  },
  methods: {
    hightLightKeyword(val, keyword) {
      val = this.$getCommonLangValue(val);
      if (val.indexOf(keyword) !== -1) {
        return val.replace(
          keyword,
          `<font style='background-color:rgba(0,0,0,0.12)'>${keyword}</font>`
        );
      } else {
        return val;
      }
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
        } else {
          this.$router.back();
        }
      }
    },
    removeOrg(item) {
      const index = this.announcementData.send_org_level_uuid.indexOf(item);
      if (index >= 0)
        this.announcementData.send_org_level_uuid.splice(index, 1);
    },

    toDelete() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    getorg: function (uuids) {
      let arr = [];
      const that = this;
      if (!uuids) arr = [];
      function getSon(items) {
        let arr1 = [];
        items.map((item) => {
          if (uuids.indexOf(item.uuid) != -1) {
            arr1.push(item);
          }
          if (item.son_org && item.son_org.length) {
            arr1 = arr1.concat(getSon(item.son_org));
          }
        });
        return arr1;
      }
      if (that.orgData.length) arr = getSon(that.orgData);
      return arr;
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let uuids = [];
      this.announcementData.send_org_level_uuid.map((item) => {
        uuids.push(item.uuid);
      });
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/update/",
        data: {
          uuid: this.$route.params.id,
          message_title: this.announcementData.message_title,
          message_content: this.announcementData.message_content,
          send_org_level_uuid: uuids.join(","),
          send_start_utc_datetime: this.$getTimeValue(
            this.announcementData.send_start_utc_datetime
          ),
          send_end_utc_datetime: this.$getTimeValue(
            this.announcementData.send_end_utc_datetime
          ),
          is_confirm_read: this.announcementData.is_confirm_read,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimReason_list_updateAnnouncementSuccessLabel"
          ),
          type: "success",
        });
        that.toBack(); //回到不能编辑状态
        that.toBack(); //返回到列表界面
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        if (res.data && res.data.send_org_level_uuid)
          res.data.send_org_level_uuid = that.getorg(
            res.data.send_org_level_uuid.split(",")
          );
        res.data.send_start_utc_datetime = that.$getDateTime(
          res.data.send_start_utc_datetime,
          "YYYY-MM-DD HH:mm"
        );
        res.data.send_end_utc_datetime = that.$getDateTime(
          res.data.send_end_utc_datetime,
          "YYYY-MM-DD HH:mm"
        );
        this.dateTerminal =
          res.data.send_start_utc_datetime +
          " - " +
          res.data.send_end_utc_datetime;
        if (res.data.is_confirm_read !== undefined)
          res.data.is_confirm_read = Number(res.data.is_confirm_read);
        that.announcementData = res.data;
      });
    },
    getOrgList: function () {
      const that = this;
      this.$getStaffList({}, true, false).then((res) => {
        if (JSON.stringify(res) == "{}" || !res) {
          that.orgData = [];
        } else {
          that.orgData = [res];
        }
        that.getDetail();
      });
    },
  },
};
</script>
